import { defaultAxios } from '@/services';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

export type AnalyzeFeedbackPeakParams = {
  filterSet: StructuredFilter;
  frequency?: number | null;
};

export type AnalyzeFeedbackPeakResponse = {
  text: string;
};

export const analyzeFeedbackPeak = async ({
  filterSet,
  frequency,
}: AnalyzeFeedbackPeakParams): Promise<AnalyzeFeedbackPeakResponse> => {
  const wa = getCurrWorkspaceAlias();
  const res = await defaultAxios.post<AnalyzeFeedbackPeakResponse>(
    `v1/workspaces/${wa}/change_drivers`,
    {
      filter_set: filterSet,
      frequency,
    },
  );

  return res.data;
};
